export class URLParams {

    userName:string;
    partNumber:string;
    partRevision:string;
    partClass:string;
    userCategory:string;
    changeNumber:string;
    status:string;
    skipFCRemoteList?:string;
}
